import React, { FC, useEffect, useState } from "react";
import {
  MetricSettingsTitle,
  RadioWrapper,
  HeadWrapper,
  LeftSideData,
  YAxisMetricData,
  ChartWrapper,
  AreaContainer,
  BottomData,
  Area,
  Area2,
  ChartDot,
  AreaTop,
  GraphWrapper,
  LegendItem,
  TraficDot,
  TraficName,
  LegendWrapper,
  LabelMetric,
  Overlay,
  Spinner,
  ChartLine,
  PlotRow,
} from './styles'
import { InfoContainer, InfoTitle } from "../info-block/styles";
import { useTranslation } from "react-i18next";
import RadioButtonGroup from "../radiobuttons";
import Select from "../select";
import { timeConverterMMDDYYHHMM } from "../../utils/dates";
import Typography from "../typography";
import DateView, { DateGrid, selectDateTicks } from "./dateView";
import { BodyDefault } from "../typography/styled";
import { useMediaQuery } from '../../hooks/useMediaQuery'

type MetricProps = {
  title:string,
  data:any[],
  dataSecond?:any[],
  customStyles?:any,
  isCpu?:boolean,
  updateData:(hours:string, type?:any) => void,
  scales?:any[],
  loading:boolean,
  scalesCpu?:any[],
  wihoutDates?:boolean,
  hideSelect?:boolean,
  customTabs?:any[],
  initialPeriod?:string,
  customDataSelect?:any[],
  isBareMetal?:boolean,
  affiliate?:boolean,
  cpuLabel?:string,
}

const MetricsChart:FC<MetricProps> = (props) => {
  const {
    title,
    data,
    customStyles,
    isCpu,
    dataSecond=[],
    updateData,
    scales,
    loading,
    scalesCpu,
    wihoutDates,
    hideSelect,
    customTabs,
    initialPeriod,
    customDataSelect,
    isBareMetal,
    affiliate,
    cpuLabel = 'CPU',
  } = props;
  const [t] = useTranslation()
  const [period, setPeriod] = useState<string>(initialPeriod ?? (affiliate ? '11111' : customTabs ? customTabs?.[0]?.value : '1'))
  const [selectData] = useState<any[]>(customDataSelect ? customDataSelect : [{label:t('PACKETS'), value:'1'}, {label:t('BYTES'), value:'2'}])
  const [networkType, setNetworkType] = useState<string>('1')
  const [checked, setChecked] = useState<any[]>([])
  const isMobile = useMediaQuery('(max-width: 768px)')
  const dateTicks = selectDateTicks(data || [], isMobile ? 4 : 8)
  const gridTicks = selectDateTicks(data || [], isMobile ? 4 : 12)
  const activeScale = isCpu ? scalesCpu : networkType === '1' ? scales?.[0] : scales?.[1]

  const editChecked = (met:any) => {
    if(met === null) {
      setChecked([])
      return
    }
    const founded = checked.find((item:any) => item === met)
    if(founded) {
      setChecked((prev:any) => {
        return prev.filter((item:any) => item !== met)
      })
    } else {
      setChecked((prev) => [...prev, met])
    }
  } 
  const tabs = [
    {
      title:t("LAST_HOUR"),
      value:'1',
      id:'1'
    },
    {
      title:t("24_HOURS"),
      value:'24',
      id:'2'
    },
    {
      title:t("7_DAYS"),
      value:'168',
      id:'3'
    },
    {
      title:t("30_DAYS"),
      value:'720',
      id:'4'
    }
  ]
  useEffect(() => {
    if(networkType === '1') {
      updateData(period)
    } else {
      updateData(period, '2')
    }
    // setChecked([])
  },[period, networkType])
  // if(isCpu && data?.length === 0) return(
  //   <BodyDefault>
  //     {t("HAS_NO_METRICS_YET")}
  //   </BodyDefault>
  // )
  // if(!isCpu && data?.length === 0 && dataSecond?.length === 0) return(
  //   <BodyDefault>
  //     {t("HAS_NO_METRICS_YET")}
  //   </BodyDefault>
  // )
  return(
    <InfoContainer
      customStyles={{
        display:'flex',
          ...customStyles
        }}
      >
      <HeadWrapper>
        <InfoTitle>
          {title}
        </InfoTitle>
        {(!isCpu && !hideSelect && !isBareMetal) &&
          <Select
            data={selectData}
            title=''
            toolTip={false}
            isSmall
            onChange={setNetworkType}
            selectedValue={networkType}
          />
        }
      </HeadWrapper>
      {wihoutDates ? null :
        <>
          <MetricSettingsTitle>
            {t("PERIOD")}
          </MetricSettingsTitle>
          <RadioWrapper>
            
          <Overlay active={loading}/>
            <RadioButtonGroup
              buttons={customTabs ?? tabs}
              title=''
              isSmall
              toolTip={false}
              selectedButton={period}
              onChange={setPeriod}
              // disabled={data?.length === 0}
            />
          </RadioWrapper>
        </>
      }
      {(data?.length === 0 && (isCpu || (!isCpu && dataSecond?.length === 0))) ? (
        <>
          {loading ?
            <Spinner/>
          :
            <BodyDefault style={{marginTop:'20px'}}>
              {t("HAS_NO_METRICS_YET")}
            </BodyDefault>
          }
        </>
        ) 
      :
        <ChartWrapper>
          <Overlay active={loading}>
            <Spinner/>
          </Overlay>
          <AreaContainer>
            <GraphWrapper>
              <PlotRow>
                <LeftSideData>
                  {activeScale?.map((item:any, index:number) => (
                    <YAxisMetricData
                      key={`${item}-${index}`}
                      $position={activeScale.length > 1 ? (index * 100) / (activeScale.length - 1) : 0}
                    >
                      {item}
                    </YAxisMetricData>
                  ))}
                </LeftSideData>
                <AreaTop>
                  <div>
                    {!loading && <DateGrid data={gridTicks} />}
                    {!checked.find((item) => item === (networkType === '1' ? `Packets in` : `Bytes in`)) &&
                      data?.length > 1 &&
                      <>
                        <Area data={data.map((item:any) => `${item[0]}% ${100 - item[1]}%` )} />
                        <ChartLine viewBox="0 0 100 100" preserveAspectRatio="none" aria-hidden="true">
                          <polyline points={data.map((item:any) => `${item[0]},${100 - item[1]}`).join(' ')}/>
                        </ChartLine>
                      </>
                    }
                    {/* <Area2 data={data.map((item:any) => `${item[0]}% ${100 - item[1]}%` )} /> */}
                    {!checked.find((item) => item === (networkType === '1' ? `Packets in` : `Bytes in`)) &&
                      data.map((item:any, index:any) => (
                      <LineChart
                        key={`${item[2] ?? 'point'}-${index}`}
                        label={affiliate ? t("CONVERSIONS_IN") : isBareMetal ? `In` : isCpu ? cpuLabel : networkType === '1' ? 'Packets in' : 'Bytes in'}
                        isCpu={isCpu}
                        item={item}
                        index={index}
                        labelOrientation={data?.length / 2 > index}
                      />
                    ))}
                    {!checked.find((item) => item === (networkType === '1' ? `Packets out` : `Bytes out`)) &&
                      dataSecond?.length > 0 &&
                      <>
                        {dataSecond.length > 1 &&
                          <>
                            <Area2 data={dataSecond.map((item:any) => `${item[0]}% ${100 - item[1]}%`)} />
                            <ChartLine $second viewBox="0 0 100 100" preserveAspectRatio="none" aria-hidden="true">
                              <polyline points={dataSecond.map((item:any) => `${item[0]},${100 - item[1]}`).join(' ')}/>
                            </ChartLine>
                          </>
                        }
                        {dataSecond.map((item:any, index:any) => (
                          <LineChart
                            key={`${item[2] ?? 'point'}-${index}`}
                            label={affiliate ? t("COMMISSIONS_IN") : isBareMetal ? 'Out' : networkType === '1' ? 'Packets out' : 'Bytes out'}
                            isCpu={isCpu}
                            second
                            item={item}
                            index={index}
                            labelOrientation={dataSecond?.length / 2 > index}
                          />
                        ))}
                      </>
                    }
                  </div>
                </AreaTop>
                <BottomData>
                  {!loading &&
                    <DateView hours={period} data={dateTicks} isMobile={isMobile}/>
                  }
                </BottomData>
              </PlotRow>
            </GraphWrapper>
              {isCpu ?
                <LegendWrapper>
                  <LegendItem>
                    <TraficDot/>
                    <TraficName>
                      {cpuLabel}
                    </TraficName>
                  </LegendItem>
                </LegendWrapper>
              :
                <LegendWrapper>
                  <LegendItem onClick={() => editChecked(networkType === '1' ? `Packets in` : `Bytes in`)}>
                    <TraficDot/>
                    <TraficName inactive={checked.find((item) => item === (networkType === '1' ? `Packets in` : `Bytes in`))}>
                      {affiliate ? t("CONVERSIONS_IN") : networkType === '1' ? isBareMetal ? `In` : `Packets in` : `Bytes in`}
                    </TraficName>
                  </LegendItem>
                  <LegendItem onClick={() => editChecked(networkType === '1' ? `Packets out` : `Bytes out`)}>
                    <TraficDot second/>
                    <TraficName inactive={checked.find((item) => item === (networkType === '1' ? `Packets out` : `Bytes out`))}>
                      {affiliate ? t("COMMISSIONS_IN") : networkType === '1' ? isBareMetal ? `Out` : `Packets out` : `Bytes out`}
                    </TraficName>
                  </LegendItem>
                </LegendWrapper>
              }
          </AreaContainer>
        </ChartWrapper>
      }
    </InfoContainer>
  )
}

export default MetricsChart


const LineChart:FC<any> = (props) => {
  const [hover, setHover] = useState<boolean>(false)

  return (
    <>
      <ChartDot
        onMouseLeave={() => setHover(false)}
        onMouseEnter={() => setHover(true)}
        second={props.second}
        style={{bottom:`${props.item[1]}%`, left:`${props.item[0]}%`}}
      />
      {hover &&
        <LabelMetric style={props?.labelOrientation ? {bottom:`calc(${props.item[1]}% + 6px)`, left:`${props.item[0]}%`} : {bottom:`calc(${props.item[1]}% + 6px)`, left:`calc(${props.item[0]}% - 146px)`}} orientation={props?.labelOrientation}>
          <Typography variant="small-medium">{timeConverterMMDDYYHHMM(props?.item[2])}</Typography>
            
          <div style={{display:'flex', alignItems:'center', gap:'6px'}}>
            <TraficDot second={props.second}/>
            <Typography variant="small">{`${props?.item?.[3]} ${props?.label}`}</Typography>
          </div>
        </LabelMetric>
      }
    </>
  )
}
